import OptionsFiltersActions from './constants';
import { IActionObject, IFilterObject } from './types';

// action creators

// Sets filter for a single field type
export function setFilter(data: IFilterObject): IActionObject {
  return { type: OptionsFiltersActions.SET_FILTER, data };
}

// Clears filter for a single field type
export function clearFilter(data: IFilterObject): IActionObject {
  return { type: OptionsFiltersActions.CLEAR_FILTER, data };
}

// Clears all filters for all field types
export function clearFilters(): IActionObject {
  return { type: OptionsFiltersActions.CLEAR_FILTERS };
}
try {
    // @ts-ignore
    setFilter.displayName = "setFilter";
    // @ts-ignore
    setFilter.__docgenInfo = { "description": "", "displayName": "setFilter", "props": { "filterKey": { "defaultValue": null, "description": "", "name": "filterKey", "required": true, "type": { "name": "string" } }, "filterValue": { "defaultValue": null, "description": "", "name": "filterValue", "required": false, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/optionsFilter/actions.tsx#setFilter"] = { docgenInfo: setFilter.__docgenInfo, name: "setFilter", path: "src/store/optionsFilter/actions.tsx#setFilter" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    clearFilter.displayName = "clearFilter";
    // @ts-ignore
    clearFilter.__docgenInfo = { "description": "", "displayName": "clearFilter", "props": { "filterKey": { "defaultValue": null, "description": "", "name": "filterKey", "required": true, "type": { "name": "string" } }, "filterValue": { "defaultValue": null, "description": "", "name": "filterValue", "required": false, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/optionsFilter/actions.tsx#clearFilter"] = { docgenInfo: clearFilter.__docgenInfo, name: "clearFilter", path: "src/store/optionsFilter/actions.tsx#clearFilter" };
}
catch (__react_docgen_typescript_loader_error) { }